module.exports = __webpack_public_path__ + "static/media/menu.a209cb50.svg";